import { useEffect, useRef, useState } from "react";
import { useAuthContext } from "components/context/authContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Header from "./header";
import Main from "./main";
import Modal from "components/modal/modal";
import Loading from "./loading";
import Footer from "./footer";
import Alert from "components/alert";
import * as constent from "util/constent";
import { alertControl } from "util/commAction";
import { useTranslation } from "react-i18next";

export default function Layout() {
  const { t } = useTranslation();

  const { viewPort, setViewPorot, setIsLogin, setUserInf } = useAuthContext();

  const { pathname } = useLocation();
  const { lodNo } = useParams();
  const navigate = useNavigate();

  const [isVisibleBtn, setIsVisibleBtn] = useState(false); // top button visible

  const handleResize = () => {
    setViewPorot({
      width: window.innerWidth,
      height: window.innerHeight,
      screen: window.innerWidth > 768 ? "web" : "mb",
    });
  };

  useEffect(() => {
    handleResize();

    window.addEventListener("resize", handleResize);
    // window.addEventListener("scroll", setVh);
    return () => {
      window.removeEventListener("resize", handleResize);
      // window.addEventListener("scroll", setVh);
    };
  }, []);

  useEffect(() => {
    const setVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    setVh();
    window.addEventListener("resize", setVh);
    window.addEventListener("scroll", setVh, { passive: true });

    return () => {
      window.removeEventListener("resize", setVh);
      window.removeEventListener("scroll", setVh);
    };
  }, []);

  useEffect(() => {
    if (pathname.includes("undefined")) {
      alertControl({
        isOpen: true,
        inner: t("alr_lod_no_select"),
        click: () => {
          navigate("/");
        },
      });
    }
    if (!pathname.includes("book")) {
      localStorage.removeItem("bookInf");
      localStorage.removeItem("bkUserInf");
      localStorage.removeItem("bkStep");
      localStorage.removeItem("terms");
      localStorage.removeItem("payRgSeq");
    }

    if (!pathname.includes("join") || pathname == "/join") {
      localStorage.removeItem("joinInf");
    }

    if (pathname === "/") {
      localStorage.removeItem("lodInf");
    }
  }, [pathname]);

  const handleSessionTimeout = (e: any) => {
    sessionStorage.removeItem("isLogin");
    localStorage.removeItem("userInf");
    setIsLogin(false);
    setUserInf(null);
  };

  useEffect(() => {
    window.addEventListener(
      constent.CONST_COMN_SESSION_TIME_OUT,
      handleSessionTimeout
    );

    return () => {
      window.removeEventListener(
        constent.CONST_COMN_SESSION_TIME_OUT,
        handleSessionTimeout
      );
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  //수직 스크롤 위치 가져오기
  const onScroll = () => {
    const scrollY = window.scrollY;
    const scrollHeight = document.documentElement.scrollHeight;

    const isAble = scrollHeight - (scrollY + window.innerHeight) < 200;
    setIsVisibleBtn(isAble);
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  // const navigationType = useNavigationType();

  // useEffect(() => {
  //   const handlePopState = () => {
  //     alert("페이지 이동");
  //   };

  //   window.addEventListener("popstate", handlePopState);

  //   return () => {
  //     window.removeEventListener("popstate", handlePopState);
  //   };
  // }, [navigationType]);

  return (
    <>
      <section>
        <Header />
        <div
          className={
            "inner" +
            " " +
            (pathname === "/" + lodNo ||
            (pathname === "/sample/" + lodNo && viewPort?.screen === "web")
              ? "w-md"
              : "")
          }
        >
          <Main />
          <Footer />
        </div>
      </section>
      <Modal />
      <Alert />
      <Loading />
      <button
        className={"btn icon-top" + " " + (isVisibleBtn ? "go-top" : "")}
        onClick={() => {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }}
      />
    </>
  );
}
